import { useCallback } from 'react';
import { useCheckCondition } from '../hooks/useCheckCondition';
import { GenericValue, ViewableQuestion } from '../types/global';
import { Connection, InsertableQuestion } from '../types/kb';
import { useSelector } from 'react-redux';
import { RootState } from '../types/graph';
import { processLabel } from './questionnaire-computations';

export const useTransformEdges = () => {
  const checkCondition = useCheckCondition();

  return useCallback(
    <T>(
      connection: Connection<T>,
      excludeQuestionId?: ViewableQuestion['extId'],
    ) =>
      connection.edges
        .filter((e) =>
          checkCondition(e.properties?.condition, excludeQuestionId),
        )
        .map((e) => e.node),
    [checkCondition],
  );
};

export const squashEdges = <T>(connection: Connection<T>) =>
  connection.edges.map((e) => ({
    ...e.node,
    condition: e.properties?.condition,
  }));

export const getFirstValue = <T>(items: GenericValue<T>[]) => items?.[0]?.value;

export const transformInserts = (insertions: InsertableQuestion[]) =>
  insertions.map((q: InsertableQuestion) => ({
    extId: q.extId,
  }));

export const useProcessLabel = () => {
  const patient = useSelector((state: RootState) => state.consultation.patient);
  const professional = useSelector(
    (state: RootState) => state.consultation.professional,
  );
  const practice = useSelector(
    (state: RootState) => state.consultation.practice,
  );

  return useCallback(
    (label: string) =>
      processLabel(label, {
        patient,
        professional,
        practice,
      }),
    [patient, professional, practice],
  );
};
